import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-text-input-dialog',
  templateUrl: './text-input-dialog.component.html',
  styleUrls: ['./text-input-dialog.component.css']
})
export class TextInputDialogComponent implements OnInit {

  @Input() text: string = '';
  @Input() callback: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  async cancel() {
    //Close dialog
    await this.activeModal.close(undefined);
  }

  async ok() {
    //Close dialog
    await this.activeModal.close(undefined);
    if (typeof (this.callback) == 'function') this.callback();
  }

}
